import { Comment } from './api';

export const COMMENT_EVENT_NAMES = {
  created: '.comment.created',
  updated: '.comment.updated',
  deleted: '.comment.deleted',
} as const;

export interface CommentCreatedEvent {
  comment: Comment;
  board_id: number;
}

export interface CommentUpdatedEvent {
  comment: Comment;
  board_id: number;
}

export interface CommentDeletedEvent {
  comment_id: number;
  card_id: number;
  board_id: number;
}

// Reflète Card::comments() (orderBy created_at desc) : jamais l'ordre d'arrivée réseau.
const sortByCreatedAtDesc = (comments: Comment[]): Comment[] =>
  [...comments].sort((a, b) => (a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0));

export const applyCommentCreated = (comments: Comment[], cardId: number, event: CommentCreatedEvent): Comment[] => {
  if (event.comment.card_id !== cardId) return comments;
  if (comments.some((c) => c.id === event.comment.id)) return comments;
  return sortByCreatedAtDesc([...comments, event.comment]);
};

export const applyCommentUpdated = (comments: Comment[], cardId: number, event: CommentUpdatedEvent): Comment[] => {
  if (event.comment.card_id !== cardId) return comments;
  if (!comments.some((c) => c.id === event.comment.id)) return comments;
  return comments.map((c) => (c.id === event.comment.id ? event.comment : c));
};

export const applyCommentDeleted = (comments: Comment[], cardId: number, event: CommentDeletedEvent): Comment[] => {
  if (event.card_id !== cardId) return comments;
  return comments.filter((c) => c.id !== event.comment_id);
};
